import { KeyValuePair } from './shared.types';

/** This function is to extract the value from a field that is linked to a KeyValue Pair item.
 * This is similar to the getDropLink function in param-utils but it is for datasource fields.
 */
export function getKvpValue<T extends string | undefined | null>(
  field?: KeyValuePair,
  defaultValue: T = '' as T
): T {
  return ((field?.fields?.Value?.value ?? '') as T) || defaultValue;
}
